import { config } from '../../config'
import { clearToken, getApiClient } from '../../utils'
import {
  ProfileChangeEmailRequest,
  ProfileChangePasswordRequest,
  ProfileConfirmEmailRequest,
  ProfileConfirmEmailResponse,
  ProfileUser,
  SaveProfileUser
} from './user.types'

export const userApi = {
  getUserInfo: (locale: string) =>
    getApiClient(locale)
      .get<{ data: ProfileUser }>('v1/users/me')
      .then(({ data }) => data.data),

  logout: (locale: string) =>
    getApiClient(locale)
      .post('v1/auth/logout')
      .then(({ data }) => {
        clearToken(config.cookiesDomain)
        return data
      }),

  saveProfile: (requestBody: SaveProfileUser, locale: string) =>
    getApiClient(locale)
      .post<{ data: ProfileUser }>('v1/users/me/profile', requestBody)
      .then(({ data }) => data.data),

  changePassword: (requestBody: ProfileChangePasswordRequest, locale: string) =>
    getApiClient(locale)
      .post('v1/users/me/password', requestBody)
      .then(({ data }) => data),

  changeEmail: (requestBody: ProfileChangeEmailRequest, locale: string) =>
    getApiClient(locale)
      .put('v1/users/me/email', requestBody)
      .then(({ data }) => data),

  confirmChangeEmail: (
    requestBody: ProfileConfirmEmailRequest,
    locale: string
  ) =>
    getApiClient(locale)
      .post<ProfileConfirmEmailResponse>(
        'v1/users/me/email/confirmation',
        requestBody
      )
      .then(({ data }) => data)
}
